export default "/assets/images/mama-to-be-crop.4ac1c1ac0b0c495e.png";